<template>
    <div class="container-fluid">
        <div class="row">
            <div class="d-flex col-sm justify-content-center">
                <h2>Pořádané akce</h2>
            </div>
        </div>
        <div class="container">
            <EventTable :small="true" :events="[
                        // { date: '1.1.2020', name: 'Začátek Roku' },
                        // { date: '6.3.2020', name: 'Otevíráme' },
                        // { date: '26.3.2020', name: 'Soukromá akce' }
            ]"/>
       </div>
    </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    var _ = require('lodash');
    // eslint-disable-next-line no-unused-vars
    const axios = require('axios');

    import EventTable from "./components/EventTable";

    export default {
        name: 'events',
        components: {EventTable}
    }
</script>

<style>
</style>
